import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

//const baseUrl = "http://localhost:9000";
const baseUrl = "https://communityoflearning.accenture.com/communityoflearning-apis";

const getAuthHeader = () => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      Authorization: token,
    },
  };
};

export const fetchDashboardStats = createAsyncThunk(
  "dashboard/fetchStats",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${baseUrl}/dashboardStats/${userId}`,
        getAuthHeader()
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch dashboard stats"
      );
    }
  }
);

export const fetchAnswersByUser = createAsyncThunk(
  "dashboard/fetchAnswersByUser",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${baseUrl}/answersByUser/${userId}`,
        getAuthHeader()
      );

      return response.data;
    } catch (error) {
      return rejectWithValue("Failed to fetch answers");
    }
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    stats: null,
    answeredList: [],   
    statsLoading: false,  
    answersLoading: false,

    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardStats.pending, (state) => {
        state.statsLoading = true;
        state.error = null;
      })
      .addCase(fetchDashboardStats.fulfilled, (state, action) => {
        state.statsLoading = false;
        state.stats = action.payload;
      })
      .addCase(fetchDashboardStats.rejected, (state, action) => {
        state.statsLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchAnswersByUser.pending, (state) => {
        state.answersLoading = true;
        state.error = null;
      })
      .addCase(fetchAnswersByUser.fulfilled, (state, action) => {
        state.answersLoading = false;
        state.answeredList = action.payload;
      })
      .addCase(fetchAnswersByUser.rejected, (state, action) => {
        state.answersLoading = false;
        state.error = action.payload;
      });
  },
});

export default dashboardSlice.reducer;